export default __webpack_public_path__ + "static/media/profile_icon.a9136072.png";